// extracted by mini-css-extract-plugin
module.exports = {"bundles":"Bundle_bundles__F0U_b"};